// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_14k29b4gZ9FLbKM00Q", // cart
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/3cs9Bt1x43xcd7a9Bp", // cart

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Cartoonify Image AI 🎨",
    HOME_PAGE_TITLE: "Home - Cartoonify Image AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - Cartoonify Image AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Cartoonify Image AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to cartoonify images, choose an image and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "cartoonify_img_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/cartoonify-img-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;